@if (languages?.length) {
  <section class="branching">
    @for (lang of languages; track lang; let langIndex = $index) {
      <div
        class="branching__language"
        >
        <div class="branching__heading">
          {{ "NEW_INJECTS.ANSWER_OPTIONS" | translate }}
          <span class="branching__heading-lang">({{ lang | uppercase }})</span>
        </div>
        <div class="branching__options">
          @for (optionIndex of optionIndexes; track optionIndex) {
            <div
              class="branching__option"
              [class.branching__option--error]="hasError(optionIndex, lang)"
              >
              <span class="branching__option-index">{{ optionIndex + 1 }}</span>
              @if (getDescriptionControl(optionIndex, lang); as control) {
                <div class="branching__fields">
                  <input
                    class="branching__input"
                    type="text"
                    [formControl]="control"
                    [attr.placeholder]="
                      'ADMIN.SESSION.SCENARIO_ITEM.OPTIONS_TITLE' | translate
                    "
                    (blur)="control.markAsTouched()"
                  />
                  @if (getCustomFeedbackControl(optionIndex, lang); as feedbackControl) {
                    <input
                      class="branching__input branching__feedback"
                      type="text"
                      [formControl]="feedbackControl"
                      [attr.placeholder]="'Custom feedback' + ' (' + (lang | uppercase) + ')'"
                    />
                  }
                </div>
              }
              @if (langIndex === 0) {
                @if (getOptionControl(optionIndex, 'is_default_option'); as defaultControl) {
                  <label
                    class="branching__default"
                    [attr.data-option]="optionIndex"
                    >
                    <input
                      type="checkbox"
                      [formControl]="defaultControl"
                      />
                    <span>{{ "BRANCHING.DEFAULT_OPTION" | translate }}</span>
                  </label>
                }
                @if (canRemoveOption) {
                  <button
                    type="button"
                    class="branching__remove"
                    (click)="confirmRemoveOption(optionIndex)"
                    [attr.aria-label]="'BRANCHING.REMOVE_OPTION' | translate"
                  >
                    <svg-icon
                      src="/static/images/trash.svg"
                      class="trash-icon"
                    ></svg-icon>
                  </button>
                }
              }
            </div>
          }
        </div>
        @if (langIndex === 0 && canAddOption) {
          <button
            type="button"
            class="branching__add"
            (click)="addOption()"
          >
            {{ "BRANCHING.ADD_OPTION" | translate }}
          </button>
        }
      </div>
    }
  </section>
} @else {
  <div class="branching__empty">
    Please add at least one language to configure branching options.
  </div>
}
